import React, { useCallback } from 'react';
import { AppButton, Box, RoundDoneIcon, Text, WarningIcon } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import ROUTES from '@/common/routes';
import { Modal } from '@/components';
import { useHasAccess } from '@/modules/core/hooks';
import useHistory from '@/modules/core/hooks/useHistory';

interface CreateServiceSuccessModalProps {
  visible: boolean;
  serviceName: string;
  onClose: () => void;
}

const CreateServiceSuccessModal: React.FC<CreateServiceSuccessModalProps> = ({
  visible,
  serviceName,
  onClose,
}) => {
  const history = useHistory();

  const isPayoutAccessible = useHasAccess([
    { permission: Permissions.MANAGE_PAYOUT_DEFINITION },
    { permission: Permissions.SET_UP_PROCESSING_DEFINITION },
  ]);

  const handleGoToServices = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleGoToPayoutDefinition = useCallback(() => {
    onClose();
    history.push(ROUTES.PAYOUT_DEFINITIONS);
  }, [onClose, history]);

  return (
    <Modal visible={visible} onSetVisible={onClose}>
      <Box direction="column" gap="spacing12" align="center" pad={{ vertical: 'spacing24' }}>
        <RoundDoneIcon size="48px" />
        <Text size="2xl" color="textTitle" weight="bold" textAlign="center">
          {serviceName} Service Created
        </Text>
        <Box
          background="warningContainer"
          border={{ size: 'small', color: 'warningBorder' }}
          round="container2Round"
          pad={{ vertical: 'spacing16', horizontal: 'spacing24' }}
          margin={{ bottom: 'spacing12' }}
          direction="row"
          align="center"
          justify="center"
          gap="spacing10"
          width="100%"
        >
          <WarningIcon size="24px" />
          <Text size="medium" color="textTitle">
            Update payout definitions to enable payments from these accounts.
          </Text>
        </Box>
        <Box direction="row" align="center" justify="center" gap="s" width="100%">
          <AppButton
            testId="create-service-success-modal_go-to-services"
            buttonType="secondary"
            width="190px"
            onClick={handleGoToServices}
          >
            Go to Services
          </AppButton>
          {isPayoutAccessible && (
            <AppButton
              testId="create-service-success-modal_go-to-payout"
              width="190px"
              onClick={handleGoToPayoutDefinition}
            >
              Go to Payout Definition
            </AppButton>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateServiceSuccessModal;
